<div class="main-container">
    <div class="filter-container">
        <h2 style="align-items: flex-end;">
            <div
                style="background-color: var(--primary-500); display: flex; border-radius: 7px; width: 27px; height: 30px;">
                <img [src]="mainIcon" alt="mainIcon" style="filter: brightness(0) invert(1); object-fit: cover;"></div>
            Import Dictionary
        </h2>
        <p>Name</p>
        <input [(ngModel)]="filterName" type="text" pInputText placeholder="Enter Name">
        <p>Start Date</p>
        <p-calendar [(ngModel)]="filterStartDate" (onchange)="onApplyClick()" [maxDate]="todayDate" [showIcon]="true"
            appendTo="body" placeholder="Enter Date" dateFormat="dd/mm/yy"></p-calendar>
        <p>End Date</p>
        <p-calendar [(ngModel)]="filterEndDate" (onchange)="onApplyClick()" [maxDate]="todayDate" [showIcon]="true"
            appendTo="body" placeholder="Enter Date" dateFormat="dd/mm/yy"></p-calendar>
        <div class="button-container">
            <p-button label="Clear" (onClick)="onClearClick()" [outlined]="true" styleClass="clearBtn"></p-button>
            <p-button label="Apply" (onClick)="onApplyClick()"></p-button>
        </div>
    </div>
    <div class="result-container">
        <div class="top-section">
            <p></p>
            <p-button label="Import Dictionary" (onClick)="onImportClick()" icon="pi createIcon"></p-button>
            <p-button label="Download Template" (onClick)="onDownloadTemplate($event)"
                icon="pi downloadIcon"></p-button>
        </div>
        <p-treeTable [value]="treeNode" [resizableColumns]="true" selectionMode="checkbox"
            [(selection)]="selectedTreeNode" (onSort)="onSort($event)">
            <ng-template pTemplate="header">
                <tr [ngStyle]="{}">
                    <th [ngStyle]="{'width': '22%', 'border-top-left-radius': '20px', 'border-bottom-left-radius': '20px'}"
                        ttSortableColumn="Filename">
                        FileName<p-treeTableSortIcon field="ScrapingScript"></p-treeTableSortIcon>
                    </th>
                    <th [ngStyle]="{'width': '12%'}" [ttSortableColumn]="'Date'">Date<p-treeTableSortIcon
                            [field]="'Date'"></p-treeTableSortIcon></th>
                    <th [ngStyle]="{'width': '17%'}">Info</th>
                    <th [ngStyle]="{'width': '13%'}" [ttSortableColumn]="'Quantity'">Quantity<p-treeTableSortIcon
                            [field]="'Quantity'"></p-treeTableSortIcon></th>
                    <th class="center-th status" [ngStyle]="{'width': '14%'}" [ttSortableColumn]="'Status'">Status</th>
                    <th
                        [ngStyle]="{'width': '27%', 'border-top-right-radius': '20px', 'border-bottom-right-radius': '20px'}">
                        Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                <ng-container *ngIf="totalRecord !== 0 || totalRecord !== null">
                    <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode"
                    [ngClass]="{'highlight-active': rowData.Status && rowData._id && rowData.hasChildren,
                    'highlightChild-active': rowData.Status && rowData._id && !rowData.hasChildren,'request': rowData.hasChildren}">
                    <td>
                        <div class="file-name">
                            <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                        {{ rowData.Filename ? rowData.Filename : rowData._id }}
                        </div>
                        
                    </td>
                    <td>{{ rowData.Date | date: 'dd/MM/yyyy' }}</td>
                    <td pTooltip="{{rowData.Information}}" tooltipPosition="top">
                        <div class="information">
                            {{rowData.Information}}
                        </div>
                    </td>
                    <td>{{ rowData.Quantity }} 
                        <span style="color: green;" *ngIf="rowData.hasChildren && rowData.ActivatedAppendQuantity">
                          (+{{rowData.ActivatedAppendQuantity}})
                        </span>
                        </td>
                    <td>
                        <ng-container *ngIf="rowData.Status">
                            <div class="status-container">
                                <div [ngClass]="[ rowData.hasChildren ? 'request' : 'status-append']">
                                    {{ rowData.Status && rowData._id ? 'Active' : '' }}</div>
                            </div>
                        </ng-container>
                    </td>
                    <td>
                        <div class="button-contain">
                            <div class="active-button" *ngIf ="!rowData.Status">
                                <p-button label="Activate"  severity="success" (onClick)="onClickActiveButton($event,rowData._id)"
                                [hidden]="!rowData.hasChildren"
                                [class.active]="!rowData.Status && rowData._id"></p-button>
                            </div>
                            <div class="active-button" *ngIf ="rowData.Status">
                                <p-button label="Deactivate"  severity="danger" (onClick)="onClickActiveButton($event,rowData._id)"
                                [hidden]="!rowData.hasChildren"
                                [class.active]="!rowData.Status && rowData._id"></p-button>
                            </div>
                            <ng-container *ngIf="!rowData.hasChildren">
                                <p-inputSwitch [(ngModel)]="rowData.Status" (onChange)="onClickActiveButton($event,rowData._id)" tooltipPosition="top"/>
                            </ng-container>
                            <div *ngIf="rowData.hasChildren">
                                <p-button icon="pi uploadIcon" pTooltip="Upload" tooltipPosition="top"
                                    (onClick)="onUploadClick(rowData._id)" [rounded]="true" [text]="true"></p-button>
                            </div>
                            <div >
                                <p-button icon="pi downloadTableIcon" pTooltip="Download" tooltipPosition="top" severity="Info"
                                    (onClick)="onDownloadClick(rowData)" [rounded]="true" [text]="true" ></p-button>
                            </div>
                            <p-button (onClick)="onDeleteClick(rowData)" icon="pi deleteBtnIcon" severity="danger"
                                pTooltip="Delete" tooltipPosition="top" [rounded]="true" [text]="true"></p-button>
                        </div>
                    </td>
                </tr>
                </ng-container>
            </ng-template>
        </p-treeTable>
        <ng-container *ngIf="totalRecord === 0|| totalRecord === null">
            <div class="upload" style=" width: 100%;">
                <div (click)="onImportClick()">
                    <i class="pi pi-cloud-upload icon-upload" style="font-size: 70px;"></i> 
                </div>
                <p>Click to import dictionary.</p>     
            </div>
        </ng-container>
        <ng-container *ngIf="totalRecord !== 0 || totalRecord !== null">
            <div class="bottom-section">
            <p-dropdown [(ngModel)]="pageSize" [options]="pageSizeList" (onChange)="onPageSizeChange($event)"></p-dropdown>
            <p>{{ getRequestBegin() + 1 }} ถึง {{ getRequestEnd() }} จาก {{ totalRecord }} รายการ</p>
            <div class="button-container">
                <button (click)="onToBeginningClick()"><img [src]="toBeginningIcon" alt="beginning"></button>
                <button (click)="onBackClick()"><img [src]="backIcon" alt="back"></button>
                <button class="pageBtn" *ngFor="let i of [4, 3, 2, 1]" (click)="goto(currentPage - i)" [ngClass]="{'hidden': !isActiveButton(currentPage - i)}">{{ currentPage - i }}</button>
                <button (click)="onPageNumberClick()" class="currentBtn">{{ currentPage }}</button>
                <button class="pageBtn" *ngFor="let i of [1, 2, 3, 4]" (click)="goto(currentPage + i)" [ngClass]="{'hidden': !isActiveButton(currentPage + i)}">{{ currentPage + i }}</button>
                <button (click)="onNextClick()"><img [src]="nextIcon" alt="next"></button>
                <button (click)="onToLastClick()"><img [src]="toLastIcon" alt="last"></button>
            </div>
            <p-dialog [style]="{'width': 'fit-content', 'height': 'fit-contenet'}" [(visible)]="goto_dialog_visible" [modal]="true" [draggable]="false" [resizable]="false">
                <div class="dialog-container">
                    Goto: <p-dropdown [(ngModel)]="gotoPage" [options]="getGotoOptions()" appendTo="body"></p-dropdown>
                    <button (click)="onGotoClick()">Go</button>
                </div>
            </p-dialog>
        </div>
        </ng-container>
        
    </div>
    <p-toast></p-toast>
    <p-confirmDialog #cd [style]="{width: '50vw'}">
        <ng-template pTemplate="header">
            <h3>Confirmation</h3>
        </ng-template>
        <ng-template pTemplate="footer">
            <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
            <button type="button" pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"></button>
        </ng-template>
    </p-confirmDialog>
    <p-dialog [style]="{'width': '50vw'}" [(visible)]="dialog_visible" [modal]="true" [draggable]="false"
        [resizable]="false" [closable]="false">
        <div class="dialog-container">
            <h2>Import Dictionary</h2>
            <p></p>
            <div>
                <!-- <p>File Browser</p> -->
                <p></p>
                <p-fileUpload #fileUpload name="file[]" accept=".csv, .xls, .xlsx" (onSelect)="uploadHandler($event)"
                    [showUploadButton]="false" (onRemove)="onRemove($event)" (onClear)="onRemove($event)"
                    chooseLabel="Browse" [multiple]="false"></p-fileUpload>
                <p></p>
                <div *ngIf="uploadedFiles">
                    <div class="input-information">
                        <p>Information</p>
                        <textarea type="text" maxlength="256" [(ngModel)]="information" pInputTextarea
                            [style]="{'width': '100%', 'margin-bottom': '20px'}" #informationTextarea></textarea>
                        <span class="text-length">{{ informationTextarea.value.length }}/256</span>
                    </div>
                    <div>
                        <p></p>
                    </div>
                </div>
            </div>
            <div>
                <div class="button-container">
                    <p-button label="Cancel" [outlined]="true" (onClick)="onCancelClick()"
                        styleClass="cancelBtn"></p-button>
                    <ng-container *ngIf ="!isAppend">
                        <p-button label="Save" (onClick)="onFileSaveClick()"></p-button>
                    </ng-container>
                    <ng-container *ngIf ="isAppend">
                        <p-button label="Save" (onClick)="uploadDictionaryAppend()"></p-button>
                    </ng-container>
                </div>
            </div>
        </div>
    </p-dialog>
</div>
